import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import config from '@bingads-webui-component-legacy/config/index';
import { globalizationModelSetup } from '@bingads-webui-campaign/ads-globalization';

const originalPriceSchema = window.globalLegacySchema.get('PriceAdExtension');
const originalTableRowSchema = window.globalLegacySchema.get('PriceTableRow');

const currencyMap = {
  ALL: 'L',
  AED: 'د.إ.‏',
  ARS: '$',
  AUD: '$',
  BAM: 'KM',
  BRL: 'R$',
  CAD: '$',
  CHF: 'Fr.',
  CLP: 'CL$',
  CNY: '￥',
  COP: '$',
  DKK: 'kr.',
  EUR: '€',
  GBP: '£',
  HKD: '$',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  ISK: 'kr',
  JPY: '￥',
  MKD: 'den',
  MXN: '$',
  MYR: 'RM',
  NGN: '₦',
  NOK: 'kr',
  NZD: '$',
  PEN: 'S/.',
  PHP: '₱',
  PLN: 'zł',
  RSD: 'din.',
  SAR: 'ر.س.‏',
  SEK: 'kr',
  SGD: '$',
  THB: '฿',
  TRY: '₺',
  USD: '$',
  VEF: 'Bs.',
  VND: '₫',
  ZAR: 'R',
};

export function convertCurrencyCode(currencyCode) {
  return currencyMap[currencyCode] || currencyCode;
}

export const getSchemas = () => {
  const priceSchema = cloneDeep(originalPriceSchema);
  const tableRowSchema = cloneDeep(originalTableRowSchema);

  const { LANGUAGES, CURRENCIES } = globalizationModelSetup({
    permissions: config.get('permissions'),
    culture: config.get('culture'),
  });

  priceSchema.properties.Language.enum = LANGUAGES;
  tableRowSchema.properties.CurrencyCode.enum = CURRENCIES;

  return { priceSchema, tableRowSchema };
};
